import { mb, PanelLayout } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { DeprecatedPortalLayout } from '../../templates/deprecated-portal-layout/deprecated-portal-layout';

export type PCCommonFeedbackProps = {
  children: JSX.Element;
  rightSideBar?: JSX.Element;
  panelStyle?: StyleProp<ViewStyle>;
};
export const PCCommonFeedback = ({
  children,
  rightSideBar,
  panelStyle,
}: PCCommonFeedbackProps) => {
  return (
    <DeprecatedPortalLayout>
      <Container hasRightSideBar={!!rightSideBar}>
        <PanelLayout style={[panelStyle, mb(40)]}>{children}</PanelLayout>
        {rightSideBar}
      </Container>
    </DeprecatedPortalLayout>
  );
};

interface ContainerProps {
  hasRightSideBar: boolean;
}
export const Container = styled.View<ContainerProps>`
  flex-direction: row;
  justify-content: ${({ hasRightSideBar }) =>
    hasRightSideBar ? 'space-between' : 'center'};
`;
